import {Vector3, Matrix4, Quaternion} from 'three';

export const calculateRotMat = (coord,locY) => {
  
  let locX = new Vector3();
  locX.subVectors(coord[1],coord[0]);
  // const length = locX.length();
  locX.normalize()

  let locZ = new Vector3();
  locZ.crossVectors(locX,locY);
  const rotmat = new Matrix4();
  rotmat.makeBasis(locX, locY, locZ);
  
  return rotmat;

}

export const calculateRotQuat = (coord,locY) => {
  
  // let locX = new THREE.Vector3();
  // locX.subVectors(coord[1],coord[0]);
  // const length = locX.length();
  // locX.normalize()

  // let locZ = new THREE.Vector3();
  // locZ.crossVectors(locX,locY);
  // const rotmat = new THREE.Matrix4();
  // rotmat.makeBasis(locX, locY, locZ);

  const rotmat = calculateRotMat(coord,locY);
  const quat = new Quaternion();
  quat.setFromRotationMatrix(rotmat);

  return quat;

}